import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6b28c36c&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b28c36c')) {
      api.createRecord('6b28c36c', component.options)
    } else {
      api.reload('6b28c36c', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=6b28c36c&", function () {
      api.rerender('6b28c36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/Dashboard.vue"
export default component.exports